<script>
import Layout from "../../layouts/main";
import appConfig from "@/app.config";
import BannerApi from "@/services/banner-api";
import Vue from 'vue'
// import Promotion from "@/components/promotion";

//import DynamicMarquee from 'vue-dynamic-marquee';

// import ItemCard from "@/components/itemCard";
// import CategoryCard from "@/components/CategoryCard";

import highlightsMss from "@/components/highlights-mss";
import highlightsCard from "@/components/highlights-card-mss";


import 'vue-slick-carousel/dist/vue-slick-carousel.css'
// optional style for arrows & dots
import 'vue-slick-carousel/dist/vue-slick-carousel-theme.css'
// import carousel from 'vue-owl-carousel'
//import simplebar from "simplebar-vue";

import ReportingApi from "@/services/reporting-api";
import UsersApi from "@/services/users-api";

export default {
  page: {
    title: "Page d'Accueil",
    meta: [{ name: "description", content: appConfig.description }]
  },
  components: {
    Layout/*, simplebar, carousel, ItemCard, CategoryCard*/, highlightsMss, highlightsCard/*, Promotion*/
  },

  computed: {

    vueAppCustomerInfo() {
      const vueAppCustomerInfo = {
        address: process.env.VUE_APP_CUSTOMER_ADDRESS,
        email: process.env.VUE_APP_CUSTOMER_EMAIL,
        phone: process.env.VUE_APP_CUSTOMER_PHONE,
      };

      return vueAppCustomerInfo;
    },

    windowWidth() {
      return window.innerWidth;
    },

    role() {
      return this.$cookies.get('userr');
    }

  },

  data() {
    return {
      bannerList: [],
      isBannerTableBusy: false,

      nowAvailableItems: [],
      newSuppliers: [],
      newItems: [],

      topItems:[],
      isGetTopItemsStarting: false,

      newAccountCompanyName: null,
      newAccountCompanyPhone: null,

      homeLogos:["logo-bosch", "logo-cerva", "logo-ridgid", "logo-esab", "logo-facom", "logo-defender", "logo-tractel", "logo-3M", "logo-climax"],


      features: [
        {
          icon: "fa-shield-alt",
          color: "blue",
          title: "Sécurité & Conformité",
          text: "Gestion sécurisée des données et des commandes, dans le strict respect des normes en vigueur du secteur médical."
        },
        {
          icon: "fa-stethoscope",
          color: "green",
          title: "Expertise Paramédicale",
          text: "Un grossiste spécialisé en produits parapharmaceutiques, au service des pharmacies, cliniques et professionnels de santé."
        },
        {
          icon: "fa-shipping-fast",
          color: "blue",
          title: "Livraison Rapide",
          text: "Approvisionnement continu, stocks optimisés et livraison express sur Sousse et ses régions pour ne jamais manquer de produits."
        }
      ],

    };
  },

  mounted() {

    this.findBanner(this.windowWidth);

    this.getTopTenItems();


    this.findNowAvailableItems();
    this.getNewItems();
    this.getNewSuppliers();



  },

  methods: {

      goToCatalogue() {
        this.$router.push('/catalogue')
      },
      goToCommande() {
        this.$router.push('/commande')
      },

    findBanner(windowWidth) {
      this.isBannerTableBusy = true;
      BannerApi.getBanners(windowWidth).then((result) => {
        this.bannerList = result;
      }).finally(() => {
        this.isBannerTableBusy = false;
      })
    },



    getNewSuppliers(){
      /*SuppliersApi.getAllNewSuppliers().then(
        response => {
          this.newSuppliers = response;
        }
      )*/
    },

    getNewItems(){
      /*ItemsApi.findNewItems().then(
        response => {
          this.settingsNewItemBanner.slidesToShow = response.length < 3 ? response.length : 3;
          this.newItems = response;
        }
      )*/
    },

    findNowAvailableItems(){
      /*ItemsApi.findNowAvailableItems().then(
        response => {

          this.nowAvailableItems = response;
        }
      )*/
    },


    getTopTenItems(){
            this.isGetTopItemsStarting=true
            ReportingApi.getTopTenItemsForHome().then(
                (result) => {
                    this.topItems=result.list;
                }
            ).finally(()=>{
                this.isGetTopItemsStarting=false
            })
      },

      addAccountRequest() {
        UsersApi.addAccountRequest(this.newAccountCompanyName, this.newAccountCompanyPhone)
        .then(
              (result) => {
                  if (result) {
                    Vue.prototype.$snotify.success('Votre demandée est ajoutée avec succès')
                    this.newAccountCompanyName = null;
                    this.newAccountCompanyPhone = null;
                  }
              }
            ).finally(()=>{
            })
      },

      goTopPage() {
        window.scrollTo({top: 0,left: 0,behavior: 'smooth'});
      }




  }
};
</script>


<template>
  <Layout>

    <!-- ═══════════════════════════════════════════
         HERO BANNER
    ═══════════════════════════════════════════ -->

    <b-carousel v-if="bannerList &&bannerList.length >= 1"
      :interval="5000"
      :fade="true"
      :indicators="bannerList.length > 1"
      :controls="false"
    >
      <b-carousel-slide v-if="!bannerList || !bannerList.length">
        <template #img>
          <div class="mss-about-blank-slide"></div>
        </template>
      </b-carousel-slide>
      <b-carousel-slide
        v-for="banner in bannerList"
        :key="banner.id"
      >
        <template #img>
          <img
            :src="'/api/banner/get/' + banner.generatedName"
            alt="Banner"
            class="mss-about-banner-img"
          />
        </template>
      </b-carousel-slide>
    </b-carousel>
    
    <div v-else class="mss-hero-banner">

      <!-- Graphical CSS background -->
      <div class="mss-hero-static-bg">
        <!-- Tech grid + circuit layer -->
        <div class="mss-hero-grid"></div>
        <!-- Depth rings -->
        <div class="mss-hero-ring mss-hero-ring--1"></div>
        <div class="mss-hero-ring mss-hero-ring--2"></div>
        <!-- Green glow -->
        <div class="mss-hero-glow"></div>
        <!-- Floating pharma + IT icons -->
        <div class="mss-hero-float mss-float-1"><i class="fas fa-pump-soap"></i></div>
        <div class="mss-hero-float mss-float-2"><i class="fas fa-microchip"></i></div>
        <div class="mss-hero-float mss-float-3"><i class="fas fa-stethoscope"></i></div>
        <div class="mss-hero-float mss-float-4"><i class="fas fa-atom"></i></div>
        <div class="mss-hero-float mss-float-5"><i class="fas fa-database"></i></div>
        <div class="mss-hero-float mss-float-6"><i class="fas fa-heartbeat"></i></div>
        <div class="mss-hero-float mss-float-7"><i class="fas fa-thermometer-half"></i></div>
        <div class="mss-hero-float mss-float-8"><i class="fas fa-shield-alt"></i></div>
        <div class="mss-hero-float mss-float-9"><i class="fas fa-laptop-medical"></i></div>
        <div class="mss-hero-float mss-float-10"><i class="fas fa-syringe"></i></div>
      </div>

      <!-- Main content layer -->
      <div class="mss-hero-content-wrap">
        <div class="home-page-80-width">
          <div class="mss-hero-content text-center">

            <!-- MSS Logo -->
            <div class="mss-hero-logo-wrap mb-4">
              <img src="@/assets/images/mss/logo.png" alt="MSS" class="mss-hero-logo" />
            </div>

            <!-- Headline -->
            <h1 class="mss-hero-title">
              Médical Santé Service
            </h1>

            <!-- Green accent underline -->
            <div class="mss-hero-accent-line mt-3 mx-auto"></div>

            <!-- Subtitle -->
            <p class="mss-hero-sub mt-3">
              Grossiste répartiteur en parapharmacie
            </p>

            <!-- Description -->
            <p class="mss-hero-desc mt-2 d-none d-md-block mx-auto">
              Votre partenaire de référence pour les pharmacies, cliniques et professionnels de santé —
              catalogue complet, approvisionnement régulier et livraison rapide sur Sousse et ses régions.
            </p>

            <!-- CTAs -->
            <div class="mss-hero-btns mt-4 justify-content-center">
              <button class="mss-btn-hero-outline mb-2" @click="goToCatalogue">
                <i class="fas fa-th-large mr-2"></i>CONSULTER LE CATALOGUE
              </button>
              <button class="mss-btn-hero-primary mb-2" @click="goToCatalogue">
                PASSER COMMANDE <i class="fas fa-arrow-right ml-2"></i>
              </button>
            </div>

          </div>
        </div>
      </div>

      <!-- Bottom stats strip -->
      <div class="mss-hero-statsbar">
        <div class="home-page-80-width">
          <div class="mss-hero-stats-inner">
            <div class="mss-hero-stat-item">
              <span class="mss-hero-stat-num">500<span class="mss-hero-stat-accent">+</span></span>
              <span class="mss-hero-stat-lbl">Références produits</span>
            </div>
            <div class="mss-hero-stat-sep"></div>
            <div class="mss-hero-stat-item">
              <span class="mss-hero-stat-num">300<span class="mss-hero-stat-accent">+</span></span>
              <span class="mss-hero-stat-lbl">Clients fidèles</span>
            </div>
            <div class="mss-hero-stat-sep"></div>
            <div class="mss-hero-stat-item">
              <span class="mss-hero-stat-num">24<span class="mss-hero-stat-accent">h</span></span>
              <span class="mss-hero-stat-lbl">Délai de livraison</span>
            </div>
            <div class="mss-hero-stat-sep"></div>
            <div class="mss-hero-stat-item">
              <span class="mss-hero-stat-num">7<span class="mss-hero-stat-accent">j/7</span></span>
              <span class="mss-hero-stat-lbl">Disponibilité</span>
            </div>
          </div>
        </div>
      </div>

    </div>


    <!-- ═══════════════════════════════════════════
         QUI SOMMES NOUS
    ═══════════════════════════════════════════ -->
    <section class="mss-about-section py-5">
      <div class="home-page-80-width">
        <div class="row align-items-center">

          <!-- Banner carousel as visual -->
          <div class="col-lg-5 col-12 mb-4 mb-lg-0">
            <div class="mss-about-carousel-wrap">
              <img
                src="@/assets/images/mss/background/back.png"
                alt="Banner"
                class="mss-about-banner-img"
              />
            </div>
          </div>

          <!-- Text -->
          <div class="col-lg-7 col-12 pl-lg-5">
            <div class="mss-section-header mb-4">
              <h2 class="mss-section-title">Qui Sommes-Nous ?</h2>
              <div class="mss-section-line"></div>
            </div>

            <p class="text-dark font-size-14 mt-3">
              <strong>Médical Santé Service (MSS)</strong> est une société tunisienne spécialisée dans la distribution en gros de produits parapharmaceutiques et de dispositifs médicaux, établie à <strong>Hammam Sousse</strong>.
            </p>
            <p class="text-secondary font-size-14 mt-3">
              Fondée avec pour ambition de devenir un partenaire de référence dans la distribution para-pharmaceutique en Tunisie, MSS s'appuie sur un réseau solide de fournisseurs et de partenaires leaders du secteur pour offrir à ses clients — pharmacies, cliniques et professionnels de santé — un catalogue complet, un approvisionnement régulier et une logistique maîtrisée.
            </p>
            <p class="text-secondary font-size-14 mt-2">
              Notre engagement : <strong class="text-primary">qualité</strong>, <strong class="text-primary">réactivité</strong> et <strong class="text-primary">proximité</strong> avec chaque client, dans le respect des normes du secteur médical.
            </p>


          </div>
        </div>
      </div>
    </section>


    <!-- ═══════════════════════════════════════════
         WHY CHOOSE US
    ═══════════════════════════════════════════ -->
    <section class="mss-section-light py-5">
      <div class="home-page-80-width">

        <div class="mss-section-header mb-5">
          <h2 class="mss-section-title">Pourquoi nous choisir</h2>
          <div class="mss-section-line"></div>
          <p class="mss-section-sub mt-3">
            Parce que votre activité mérite un partenaire fiable, réactif et spécialisé.
          </p>
        </div>

        <div class="row mss-features-row">
          <div class="col-md-4 mb-4" v-for="(f, i) in features" :key="i">
            <div class="mss-feature-card">
              <div class="mss-feature-icon-circle" :class="'mss-icon-circle--' + f.color">
                <i :class="'fas ' + f.icon"></i>
              </div>
              <h5 class="mss-feature-title mt-4">{{ f.title }}</h5>
              <p class="mss-feature-text mt-3">{{ f.text }}</p>
            </div>
          </div>
        </div>

      </div>
    </section>


    <!-- ═══════════════════════════════════════════
         HIGHLIGHTS (promotions & news)
    ═══════════════════════════════════════════ -->
    <div class="bg-white">
      <div class="col-12 p-0">
        <highlightsCard :propDisplayTitle="true" />
      </div>
    </div>

    <highlightsMss :propDisplayTitle="true" />


    <!-- ═══════════════════════════════════════════
         VISIT US
    ═══════════════════════════════════════════ -->
    <section class="py-5 text-dark mss-visit-section">
      <div class="container">
        <div class="mss-section-header mb-5">
          <h2 class="mss-section-title">Nous rendre visite</h2>
          <div class="mss-section-line"></div>
          <p class="mss-section-sub mt-3">
            Venez nous rencontrer à notre dépôt de Hammam Sousse.
          </p>
        </div>

        <div class="row">

          <!-- Blue | Map | White — one unified wrapper -->
          <div class="col-12">
            <div class="mss-visit-wrapper">

              <!-- Blue brand panel (order-1 on desktop, 1st in DOM = 1st on mobile) -->
              <div class="mss-visit-brand">
                <img src="@/assets/images/mss/logo.png" alt="MSS" class="mss-visit-logo" />
                <p class="mss-visit-tagline">
                  Grossiste répartiteur en parapharmacie<br>au service des professionnels de santé
                </p>
                <div class="mss-visit-badges">
                  <div class="mss-visit-badge-item">
                    <i class="fas fa-map-marker-alt"></i>
                    <div>
                      <span class="mss-visit-badge-label">Localisation</span>
                      <span class="mss-visit-badge-val">Hammam Sousse, Tunisie</span>
                    </div>
                  </div>
                  <div class="mss-visit-badge-item">
                    <i class="fas fa-truck"></i>
                    <div>
                      <span class="mss-visit-badge-label">Livraison</span>
                      <span class="mss-visit-badge-val">Sousse et régions, livraison rapide</span>
                    </div>
                  </div>
                </div>
              </div>

              <!-- White contact panel (2nd in DOM = 2nd on mobile; order-3 on desktop) -->
              <div class="mss-visit-contact">

                <div class="d-flex align-items-start mb-4">
                  <div class="mss-info-icon flex-shrink-0 mr-3">
                    <i class="fas fa-map-marker-alt text-primary"></i>
                  </div>
                  <div>
                    <h6 class="font-weight-bold text-dark mb-1">Adresse</h6>
                    <p class="text-muted mb-0" style="font-size: 14px; line-height: 1.8;">
                      {{ vueAppCustomerInfo.address }}<br>
                      {{ vueAppCustomerInfo.phone }}<br>
                      <a :href="'mailto:' + vueAppCustomerInfo.email" class="text-primary">
                        {{ vueAppCustomerInfo.email }}
                      </a>
                    </p>
                  </div>
                </div>

                <div class="d-flex align-items-start mb-4">
                  <div class="mss-info-icon flex-shrink-0 mr-3" style="background:#f0f9e0;">
                    <i class="fas fa-clock" style="color:#8ac727;"></i>
                  </div>
                  <div>
                    <h6 class="font-weight-bold text-dark mb-2">Horaires d'ouverture</h6>
                    <ul class="list-unstyled mb-0 text-muted mss-hours-list" style="font-size: 14px;">
                      <li><span>Lundi – Vendredi</span><strong>8h00 – 18h00</strong></li>
                      <li><span>Samedi</span><strong>9h00 – 13h00</strong></li>
                      <li><span>Dimanche</span><strong>Fermé</strong></li>
                    </ul>
                  </div>
                </div>

                <b-button
                  variant="primary"
                  block
                  class="mss-btn-primary text-uppercase font-weight-bold py-2 mt-3"
                  :href="'https://www.google.com/maps/dir/?api=1&destination=' + encodeURIComponent(vueAppCustomerInfo.address)"
                  target="_blank"
                >
                  <i class="fas fa-directions mr-2"></i>Obtenir l'itinéraire
                </b-button>

              </div>

              <!-- Map panel (3rd in DOM = last on mobile; order-2 on desktop = middle) -->
              <div class="mss-visit-map">
                <iframe
                  src="https://www.google.com/maps/embed?pb=!1m14!1m8!1m3!1d35460.31738061614!2d10.597822743416762!3d35.83423530643317!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x13027524cfc2fd27%3A0x210b9dd99803a108!2sMEDICAL%20SANTE%20SERVICE%20SOUSSE%20MSS!5e0!3m2!1sfr!2stn!4v1767953637439!5m2!1sfr!2stn"
                  loading="lazy"
                  allowfullscreen
                ></iframe>
              </div>


            </div>
          </div>
        </div>
      </div>
    </section>


    <!-- ═══════════════════════════════════════════
         FOOTER
    ═══════════════════════════════════════════ -->
    <footer class="mss-footer">
      <div class="mss-footer-inner home-page-80-width py-5">
        <div class="row">

          <!-- Logo -->
          <div class="col-xl-2 col-md-6 col-12 mb-4 text-center text-md-left">
            <img src="@/assets/images/mss/logo.png" alt="MSS" height="110" />
          </div>

          <!-- Contact -->
          <div class="col-xl-4 col-md-6 col-12 mb-4">
            <h6 class="mss-footer-heading">CONTACTEZ-NOUS</h6>
            <ul class="mss-footer-list">
              <li>
                <i class="fas fa-map-marker-alt mss-footer-icon"></i>
                <span>{{vueAppCustomerInfo.address}}</span>
              </li>
              <li>
                <i class="fas fa-envelope mss-footer-icon"></i>
                <span>{{vueAppCustomerInfo.email}}</span>
              </li>
              <li>
                <i class="fas fa-clock mss-footer-icon"></i>
                <span>Du lundi au samedi de 08h à 17h</span>
              </li>
              <li>
                <i class="fas fa-phone-alt mss-footer-icon"></i>
                <span>{{vueAppCustomerInfo.phone}}</span>
              </li>
            </ul>
          </div>

          <!-- Products -->
          <div class="col-xl-3 col-md-6 col-12 mb-4">
            <h6 class="mss-footer-heading mss-footer-heading-green">NOS PRODUITS</h6>
            <ul class="mss-footer-list">
              <li><a href="/catalogue">Tout le catalogue</a></li>
              <li><a href="/catalogue">Produits Para-Pharmaceutiques</a></li>
              <li><a href="/catalogue">Dispositifs Médicaux</a></li>
            </ul>
          </div>

          <!-- Client space -->
          <div class="col-xl-2 col-md-6 col-12 mb-4">
            <h6 class="mss-footer-heading">ESPACE CLIENT</h6>
            <ul class="mss-footer-list">
              <li><a href="/profil">Profil Utilisateur</a></li>
              <li><a href="/commandes">Commandes</a></li>
            </ul>
          </div>



        </div>

  

      </div>
    </footer>

  </Layout>
</template>




<style>

.trending-content a span.img-marq {
    display: inline-block;
    line-height: 1;
    margin-right: 15px;
    position: relative;
}

.slick-arrow:before {
    font-family: 'slick';
    font-size: 20px;
    line-height: 1;
    opacity: 0.75;
    color: #787a76;
    -webkit-font-smoothing: antialiased;
    -moz-osx-font-smoothing: grayscale;
}

.slick-next:before {
    font-family: 'slick';
    font-size: 20px;
    line-height: 1;
    opacity: 0.75;
    color: #787a76;
    -webkit-font-smoothing: antialiased;
    -moz-osx-font-smoothing: grayscale;
}

.newitems .simplebar-scrollbar::before {
  background-color: #5cb45b;
}

.truncate-title {
  white-space: nowrap;
  width: 100%;
  overflow: hidden;
  text-overflow: ellipsis;
}

carousel-item .active .img-fluid {
  border-radius:500px !important;
}

@media all and (max-width: 1199px) {
    .mobile-padding {
        padding-left: 20px !important;
        padding-right: 20px !important;
    }
}

.mss-banner-overlay {
  position: absolute;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  z-index: 1;
  pointer-events: none;
}

.carousel-caption {
  position: absolute;
  top: 45%;
  left: 0;
  right: 0;
  transform: translateY(-50%);
  z-index: 2;
}

.banner-image {
  position: relative;
  z-index: 0;
}

.catalog-background {
  padding-top: 75px;
  padding-bottom: 70px;
  background-image: url('~@/assets/images/back.jpg');
  background-position: center;
  background-repeat: no-repeat;
  -webkit-background-size: cover;
  -moz-background-size: cover;
  -o-background-size: cover;
  background-size: cover;
}

.footer-default {
  background: none;
}

@media (min-width: 992px) {
  .footer-default {
    background: #f7f6f6;
  }
}

</style>



<style scoped>

/* ── Hero Banner ── */
.mss-hero-banner {
  position: relative;
  width: 100%;
  overflow: hidden;
}

/* ── Static graphical background ── */
.mss-hero-static-bg {
  width: 100%;
  height: 600px;
  background:
    radial-gradient(ellipse at 78% 18%, rgba(138, 199, 39, 0.14) 0%, transparent 52%),
    radial-gradient(ellipse at 12% 88%, rgba(24, 83, 186, 0.20) 0%, transparent 45%),
    linear-gradient(135deg, #04112e 0%, #0c2472 35%, #1853ba 65%, #0b2e8a 100%);
  position: relative;
  overflow: hidden;
}

/* Subtle tech grid / circuit board feel */
.mss-hero-grid {
  position: absolute;
  inset: 0;
  background-image:
    linear-gradient(rgba(255,255,255,0.03) 1px, transparent 1px),
    linear-gradient(90deg, rgba(255,255,255,0.03) 1px, transparent 1px),
    radial-gradient(rgba(255,255,255,0.055) 1px, transparent 1px);
  background-size: 64px 64px, 64px 64px, 32px 32px;
  pointer-events: none;
}

/* Depth rings */
.mss-hero-ring {
  position: absolute;
  border-radius: 50%;
}
.mss-hero-ring--1 {
  width: 580px; height: 580px;
  right: -100px; top: -150px;
  border: 1px solid rgba(255, 255, 255, 0.06);
}
.mss-hero-ring--2 {
  width: 340px; height: 340px;
  right: 50px; top: 30px;
  border: 1px solid rgba(138, 199, 39, 0.10);
  background: radial-gradient(circle, rgba(138,199,39,0.04) 0%, transparent 70%);
}

/* Green glow cluster top-right */
.mss-hero-glow {
  position: absolute;
  width: 460px; height: 460px;
  border-radius: 50%;
  background: radial-gradient(circle, rgba(138, 199, 39, 0.11) 0%, transparent 68%);
  right: -30px; top: -80px;
  pointer-events: none;
}

/* ── Floating pharma + IT icons (static) ── */
.mss-hero-float {
  position: absolute;
  color: rgba(255, 255, 255, 0.07);
  pointer-events: none;
  user-select: none;
}

/* Parapharma icons — green tint */
.mss-float-1  { font-size: 3.2rem; top: 10%;    right: 22%; color: rgba(138,199,39,0.10); } /* pump-soap   */
.mss-float-3  { font-size: 2.8rem; top: 18%;    right: 6%;  color: rgba(138,199,39,0.08); } /* stethoscope */
.mss-float-6  { font-size: 2.6rem; bottom: 22%; left: 6%;   color: rgba(138,199,39,0.09); } /* heartbeat   */
.mss-float-7  { font-size: 1.6rem; top: 38%;    left: 3%;   color: rgba(138,199,39,0.09); } /* thermometer */
.mss-float-10 { font-size: 2.2rem; bottom: 30%; right: 30%; color: rgba(138,199,39,0.07); } /* syringe     */

/* IT / tech icons — white tint */
.mss-float-2  { font-size: 2.4rem; top: 52%;  right: 9%;  } /* microchip      */
.mss-float-4  { font-size: 2.2rem; top: 72%;  right: 22%; } /* atom           */
.mss-float-5  { font-size: 1.8rem; top: 8%;   left: 4%;   } /* database       */
.mss-float-8  { font-size: 2rem;   bottom: 12%; right: 10%; } /* shield-alt    */
.mss-float-9  { font-size: 2rem;   top: 65%;  left: 12%;  } /* laptop-medical */

/* Content sits above carousel + overlay, leaves space for stats bar */
.mss-hero-content-wrap {
  position: absolute;
  top: 0;
  left: 0;
  right: 0;
  bottom: 84px;
  z-index: 3;
  display: flex;
  align-items: center;
}
.mss-hero-content {
  width: 100%;
  padding: 48px 0 24px;
}

/* Logo above title */
.mss-hero-logo-wrap {
  display: inline-block;
}
.mss-hero-logo {
  height: 72px;
  filter: brightness(0) invert(1);
  opacity: 0.92;
}

/* Headline */
.mss-hero-title {
  font-size: 4rem;
  font-weight: 900;
  line-height: 1.08;
  color: #ffffff;
  margin-bottom: 0;
  text-shadow: 0 2px 16px rgba(0, 0, 0, 0.25);
  letter-spacing: -0.5px;
}

/* Green accent underline */
.mss-hero-accent-line {
  width: 64px;
  height: 4px;
  background: linear-gradient(to right, #8ac727, #b2e84a);
  border-radius: 3px;
}

/* Subtitle */
.mss-hero-sub {
  font-size: 15px;
  font-weight: 600;
  color: rgba(255, 255, 255, 0.88);
  text-transform: uppercase;
  letter-spacing: 2px;
  margin-bottom: 0;
}

/* Description */
.mss-hero-desc {
  font-size: 17px;
  color: rgba(255, 255, 255, 0.82);
  line-height: 1.8;
  max-width: 620px;
}

/* CTA row */
.mss-hero-btns {
  display: flex;
  flex-wrap: wrap;
  gap: 14px;
}

/* Green solid CTA */
.mss-btn-hero-primary {
  display: inline-flex;
  align-items: center;
  background: #8ac727;
  border: none;
  color: #fff;
  font-size: 14px;
  font-weight: 700;
  padding: 13px 28px;
  border-radius: 6px;
  letter-spacing: 0.3px;
  cursor: pointer;
  transition: background 0.2s, box-shadow 0.2s, transform 0.15s;
  text-decoration: none;
}
.mss-btn-hero-primary:hover {
  background: #79b020;
  box-shadow: 0 8px 24px rgba(138, 199, 39, 0.45);
  transform: translateY(-1px);
  color: #fff;
}

/* White outline secondary CTA */
.mss-btn-hero-outline {
  display: inline-flex;
  align-items: center;
  background: transparent;
  border: 2px solid rgba(255, 255, 255, 0.65);
  color: #fff;
  font-size: 14px;
  font-weight: 600;
  padding: 11px 26px;
  border-radius: 6px;
  cursor: pointer;
  transition: background 0.2s, border-color 0.2s, transform 0.15s;
  text-decoration: none;
}
.mss-btn-hero-outline:hover {
  background: rgba(255, 255, 255, 0.12);
  border-color: #fff;
  color: #fff;
  transform: translateY(-1px);
}

/* ── Stats bar pinned to bottom of hero ── */
.mss-hero-statsbar {
  position: absolute;
  bottom: 0;
  left: 0;
  right: 0;
  z-index: 4;
  background: rgba(255, 255, 255, 0.95);
  backdrop-filter: blur(10px);
  -webkit-backdrop-filter: blur(10px);
  border-top: 1px solid rgba(24, 83, 186, 0.12);
  border-bottom: 1px solid #ddd;
}
.mss-hero-stats-inner {
  display: flex;
  align-items: stretch;
  padding: 0;
}
.mss-hero-stat-item {
  flex: 1;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  padding: 16px 12px;
}
.mss-hero-stat-num {
  font-size: 1.8rem;
  font-weight: 900;
  color: #1853ba;
  line-height: 1;
  letter-spacing: -0.5px;
}
.mss-hero-stat-accent {
  font-size: 1.1rem;
  color: #8ac727;
  font-weight: 800;
}
.mss-hero-stat-lbl {
  font-size: 10.5px;
  color: #8898aa;
  text-transform: uppercase;
  letter-spacing: 0.8px;
  margin-top: 5px;
  text-align: center;
}
.mss-hero-stat-sep {
  width: 1px;
  background: #e0e8f5;
  align-self: stretch;
  margin: 12px 0;
}

/* Responsive */
@media (max-width: 991px) {
  .mss-hero-static-bg { height: 520px; }
  .mss-hero-title { font-size: 2.8rem; }
  .mss-hero-sub { font-size: 13px; }
  .mss-hero-desc { font-size: 15px; }
  .mss-hero-content { padding: 32px 16px 20px; }

  .home-page-80-width {
    padding-left: 20px !important;
    padding-right: 20px !important;
  }
}

@media (max-width: 575px) {
  .mss-hero-static-bg { height: 580px; }
  .mss-hero-content-wrap { bottom: 100px; }
  .mss-hero-title { font-size: 2.1rem; }
  .mss-hero-sub { font-size: 12px; letter-spacing: 1.4px; }
  .mss-hero-desc { font-size: 14px; }
  .mss-hero-btns { flex-direction: column; }
  .mss-btn-hero-primary,
  .mss-btn-hero-outline { width: 100%; justify-content: center; }
  .mss-hero-stat-item { padding: 12px 6px; }
  .mss-hero-stat-num { font-size: 1.3rem; }
  .mss-hero-stat-accent { font-size: 0.9rem; }
  .mss-hero-stat-lbl { font-size: 9px; }
  .mss-hero-stat-sep { margin: 8px 0; }

  /* Give sections using home-page-80-width breathing room on mobile */
  .home-page-80-width {
    padding-left: 16px !important;
    padding-right: 16px !important;
  }

  /* Features: stack to 1 per row on very small screens */
  .mss-feature-card { padding: 24px 16px; }

  /* Visit wrapper stacks cleanly */
  .mss-visit-brand,
  .mss-visit-contact { padding: 24px 20px; }
}

/* ── About section carousel ── */
.mss-about-carousel-wrap {
  border-radius: 14px;
  overflow: hidden;
  box-shadow: 0 8px 28px rgba(24, 83, 186, 0.13);
  height: 100%;
  min-height: 340px;
}
.mss-about-carousel-wrap /deep/ .carousel-inner,
.mss-about-carousel-wrap /deep/ .carousel-item {
  height: 100%;
  min-height: 340px;
}
.mss-about-banner-img {
  width: 100%;
  height: 100%;
  min-height: 340px;
  object-fit: cover;
  display: block;
}
.mss-about-blank-slide {
  width: 100%;
  min-height: 340px;
  background: linear-gradient(135deg, #eef4ff 0%, #d6e8ff 100%);
}
.mss-about-carousel-wrap /deep/ .carousel-indicators li {
  background-color: rgba(24, 83, 186, 0.35);
  border-top: none;
  border-bottom: none;
  width: 7px;
  height: 7px;
  border-radius: 50%;
  margin: 0 3px;
}
.mss-about-carousel-wrap /deep/ .carousel-indicators li.active {
  background-color: #8ac727;
}

/* Buttons */
.mss-btn-primary {
  background-color: #1853ba;
  border-color: #1853ba;
  color: #fff;
  border-radius: 6px;
  padding: 10px 22px;
  font-size: 14px;
  font-weight: 600;
  letter-spacing: 0.5px;
  transition: background 0.2s, box-shadow 0.2s;
}
.mss-btn-primary:hover {
  background-color: #1447a0;
  border-color: #1447a0;
  box-shadow: 0 4px 14px rgba(24, 83, 186, 0.3);
}

.mss-btn-outline {
  background: transparent;
  border: 2px solid #8ac727;
  color: #8ac727;
  border-radius: 6px;
  padding: 10px 22px;
  font-size: 14px;
  font-weight: 600;
  letter-spacing: 0.5px;
  transition: background 0.2s, color 0.2s;
}
.mss-btn-outline:hover {
  background: #8ac727;
  color: #fff;
}



/* ── Qui Sommes-Nous ── */
.mss-about-section {
  background: #fff;
}
.mss-about-visual {
  background: linear-gradient(160deg, #eef4ff 0%, #f4f8ff 100%);
  border: 1px solid #d6e4f7;
  border-radius: 16px;
  padding: 36px 28px;
  text-align: center;
  box-shadow: 0 2px 12px rgba(24, 83, 186, 0.06);
  display: flex;
  flex-direction: column;
  align-items: center;
}
.mss-about-logo {
  height: 80px;
  opacity: 0.85;
  margin-bottom: 16px;
}
.mss-about-visual-tagline {
  color: #1a2340;
  font-size: 13px;
  font-weight: 600;
  line-height: 1.6;
  margin-bottom: 20px;
}
.mss-about-visual-badges {
  display: flex;
  flex-direction: column;
  gap: 12px;
  width: 100%;
}
.mss-about-badge-item {
  display: flex;
  align-items: center;
  gap: 12px;
  background: #fff;
  border: 1px solid #e4edf8;
  border-radius: 8px;
  padding: 10px 12px;
  text-align: left;
}
.mss-about-badge-icon {
  width: 32px;
  height: 32px;
  min-width: 32px;
  background: #eef4ff;
  border-radius: 6px;
  display: flex;
  align-items: center;
  justify-content: center;
  color: #1853ba;
  font-size: 13px;
}
.mss-about-badge-text {
  display: flex;
  flex-direction: column;
}
.mss-about-badge-label {
  font-size: 10px;
  text-transform: uppercase;
  letter-spacing: 0.5px;
  color: #aab4c0;
  margin-bottom: 1px;
}
.mss-about-badge-val {
  font-size: 12px;
  font-weight: 600;
  color: #3a4a5e;
}
.mss-about-stats {
  display: flex;
  flex-wrap: wrap;
  gap: 0;
  border-top: 1px solid #e8eef8;
  padding-top: 20px;
}
.mss-about-stat {
  display: flex;
  flex-direction: column;
  align-items: center;
  min-width: 100px;
  padding: 8px 16px;
  border-right: 1px solid #e8eef8;
}
.mss-about-stat:last-child {
  border-right: none;
}
.mss-about-stat-num {
  font-size: 1.7rem;
  font-weight: 800;
  color: #1853ba;
  line-height: 1;
}
.mss-about-stat-lbl {
  font-size: 11px;
  text-transform: uppercase;
  letter-spacing: 0.5px;
  color: #8898aa;
  margin-top: 4px;
  text-align: center;
}
@media (max-width: 576px) {
  .mss-about-stat { min-width: 50%; border-right: none; border-bottom: 1px solid #e8eef8; }
}

/* ── Section headers ── */
.mss-section-light {
  background: #f8fafd;
}
.mss-section-title {
  font-size: 1.65rem;
  font-weight: 800;
  color: #1853ba;
  margin-bottom: 6px;
}
.mss-section-line {
  width: 40px;
  height: 3px;
  background: #8ac727;
  border-radius: 2px;
}
.mss-section-line-green {
  width: 40px;
  height: 3px;
  background: #8ac727;
  border-radius: 2px;
}
.mss-section-sub {
  color: #8898aa;
  font-size: 14px;
  margin-bottom: 0;
}


/* ── Feature cards ── */
.mss-features-row > [class*="col"] {
  padding-left: 14px;
  padding-right: 14px;
}
.mss-feature-card {
  background: #fff;
  border-radius: 16px;
  padding: 40px 32px 36px;
  border: 1px solid #e8eef8;
  box-shadow: 0 2px 16px rgba(24, 83, 186, 0.06);
  transition: transform 0.22s ease, box-shadow 0.22s ease;
  height: 100%;
  text-align: center;
}
.mss-feature-card:hover {
  transform: translateY(-6px);
  box-shadow: 0 20px 48px rgba(24, 83, 186, 0.13);
}

/* Large gradient icon circle */
.mss-feature-icon-circle {
  width: 96px;
  height: 96px;
  border-radius: 50%;
  display: flex;
  align-items: center;
  justify-content: center;
  margin: 0 auto;
  font-size: 2.4rem;
  transition: transform 0.22s ease;
}
.mss-feature-card:hover .mss-feature-icon-circle {
  transform: scale(1.08);
}
.mss-icon-circle--blue {
  background: linear-gradient(135deg, #1853ba 0%, #2e6fd4 100%);
  color: #fff;
  box-shadow: 0 8px 24px rgba(24, 83, 186, 0.30);
}
.mss-icon-circle--green {
  background: linear-gradient(135deg, #6ab31e 0%, #8ac727 100%);
  color: #fff;
  box-shadow: 0 8px 24px rgba(138, 199, 39, 0.32);
}

.mss-feature-title {
  font-size: 17px;
  font-weight: 700;
  color: #1853ba;
  margin-bottom: 0;
}
.mss-feature-text {
  font-size: 14px;
  color: #5a6a7e;
  line-height: 1.75;
  margin-bottom: 0;
}


/* ── Contact card ── */
/* ── Unified visit wrapper ── */
.mss-visit-wrapper {
  display: flex;
  border-radius: 16px;
  overflow: hidden;
  box-shadow: 0 4px 24px rgba(24, 83, 186, 0.12);
  min-height: 380px;
}

.mss-visit-brand {
  width: 22%;
  flex-shrink: 0;
  background: linear-gradient(160deg, #0c2472 0%, #1853ba 60%, #0b2e8a 100%);
  padding: 36px 24px;
  display: flex;
  flex-direction: column;
  align-items: flex-start;
  justify-content: center;
}
.mss-visit-logo {
  height: 65px;
  filter: brightness(0) invert(1);
  opacity: 0.92;
  margin-bottom: 20px;
}
.mss-visit-tagline {
  font-size: 13px;
  color: rgba(255,255,255,0.80);
  line-height: 1.6;
  margin-bottom: 28px;
}
.mss-visit-badges {
  display: flex;
  flex-direction: column;
  gap: 16px;
  width: 100%;
}
.mss-visit-badge-item {
  display: flex;
  align-items: flex-start;
  gap: 12px;
}
.mss-visit-badge-item > i {
  font-size: 15px;
  color: #8ac727;
  margin-top: 2px;
  flex-shrink: 0;
}
.mss-visit-badge-label {
  display: block;
  font-size: 10px;
  font-weight: 700;
  text-transform: uppercase;
  letter-spacing: 0.8px;
  color: rgba(255,255,255,0.55);
  margin-bottom: 2px;
}
.mss-visit-badge-val {
  display: block;
  font-size: 13px;
  font-weight: 600;
  color: #fff;
  line-height: 1.4;
}

/* Map panel — no radius, fills full height */
.mss-visit-map {
  flex: 1;
  position: relative;
  min-height: 320px;
}
.mss-visit-map iframe {
  position: absolute;
  inset: 0;
  width: 100%;
  height: 100%;
  border: 0;
  display: block;
}

.mss-visit-contact {
  width: 30%;
  flex-shrink: 0;
  background: #fff;
  padding: 36px 28px;
  display: flex;
  flex-direction: column;
  justify-content: center;
}

.mss-info-icon {
  width: 36px;
  height: 36px;
  background: #e8f1ff;
  border-radius: 8px;
  display: flex;
  align-items: center;
  justify-content: center;
  font-size: 14px;
}
.mss-hours-list li {
  display: flex;
  justify-content: space-between;
  padding: 9px 0;
  border-bottom: 1px solid #f0f4fa;
  gap: 12px;
}

/* Desktop: brand(1) | map(2) | contact(3) — map is 2nd in desktop via order */
@media (min-width: 992px) {
  .mss-visit-brand  { order: 1; }
  .mss-visit-map    { order: 2; }
  .mss-visit-contact { order: 3; }
}

/* Mobile: stacks as brand → contact → map (DOM order, no order needed) */
@media (max-width: 991px) {
  .mss-visit-section { padding-left: 16px !important; padding-right: 16px !important; }
  .mss-visit-wrapper { flex-direction: column; min-height: auto; }
  .mss-visit-brand   { width: 100%; }
  .mss-visit-contact { width: 100%; }
  .mss-visit-map     { min-height: 260px; }
}



/* ── Footer ── */
.mss-footer {
  background: #f4f7fb;
  border-top: 1px solid #ddd;
}
.mss-footer-inner {
  padding-left: 16px;
  padding-right: 16px;
}
.mss-footer-heading {
  font-size: 12px;
  font-weight: 700;
  letter-spacing: 1px;
  color: #1853ba;
  margin-bottom: 16px;
  text-transform: uppercase;
}
.mss-footer-heading-green {
  color: #1853ba;
}
.mss-footer-list {
  list-style: none;
  padding: 0;
  margin: 0;
}
.mss-footer-list li {
  font-size: 13px;
  color: #1a2340;
  margin-bottom: 8px;
  display: flex;
  align-items: flex-start;
  gap: 8px;
}
.mss-footer-list li a {
  color: #1a2340;
  text-decoration: none;
  transition: color 0.18s;
}
.mss-footer-list li a:hover {
  color: #1853ba;
}
.mss-footer-icon {
  color: #1853ba;
  margin-top: 2px;
  flex-shrink: 0;
  width: 14px;
  text-align: center;
}
.mss-footer-top {
  font-size: 28px;
  color: #1853ba;
  transition: color 0.18s;
}
.mss-footer-top:hover {
  color: #1447a0;
}
.mss-footer-bottom {
  border-top: 1px solid #dde5f0;
  margin-top: 24px;
  padding-top: 16px;
  display: flex;
  justify-content: space-between;
  align-items: center;
  font-size: 12px;
  color: #8898aa;
}

/* Responsive tweaks */
@media (max-width: 576px) {
  .mss-figures { flex-wrap: wrap; gap: 12px; }
  .mss-figure-divider { display: none; }
}

</style>
